import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import Translator from "Languages/Utility/Translator";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  Tab,
} from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import MuiButton from "Components/MuiButton/MuiButton";
import * as Icons from "react-bootstrap-icons";
import { read } from "Helpers/LocalStorage";
import { useTranslation } from "react-i18next";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import StatusHandler from "Helpers/StatusHandler";
import showNotify from "Helpers/Notify";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";
import AddUser from "./AddUser";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useTheme } from "@material-ui/core/styles";
import DialogHead from "Components/DialogHead/DialogHead";
import UserTable from "./UserTable";

export default function Users({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [tab, setTab] = useState("users-list");
  const [loading, setLoading] = useState(false);
  const [activeButton, setActiveButton] = useState(false);
  const [addUserData, setAddUserData] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [getAgain, setGetAgain] = useState(0);
  const [credit, setCredit] = useState(0);

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onEnter = () => {
    setTab("users-list");
    setLoading(false);
    setActiveButton(false);
    setGetAgain(0);
    setCredit(0);
    setAddUserData({});
  };

  const onExit = () => {
    setShowDialog(false);
  }

  const handleChange = (event, newTab) => {
    setActiveButton(false);
    setTab(newTab);
  };

  const handleActiveShowButton = (income_data) => {
    if (income_data?.changeActive) {
      const { nuc, suc, priceShow, discount } = income_data;
      setAddUserData({
        nuc,
        suc,
        priceShow,
        discount,
      });
      setActiveButton(true);
    } else {
      setActiveButton(false);
    }
  };

  const addUser = async () => {
    try {
      if (addUserData?.nuc !== null && addUserData?.suc !== null) {
        setLoading(true);
        const data = {
          KeyGroup: read("groupAKey"),
          KeyUser: read("userAKey"),
          GroupId: row.Id,
          Count: addUserData.nuc,
          DiscountCode: addUserData.discount,
          CountSuperVisor: addUserData.suc,
          TypePayment: 2,
        };
        const response = await AccountService.postUpgradeFinal(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          if (response.data.Value.IsError === true) {
            showNotify({
              text: response.data.Value.Describ,
              customClass: "error",
            });
          } else {
            showNotify({
              text: t("mission_accomplished"),
              customClass: "success",
            });
            setTimeout(() => {
              setTab("users-list");
              setActiveButton(false);
              setLoading(false);
            }, 200);
            return true;
          }
        } else {
          setLoading(false);
          setActiveButton(false);
        }
      } else {
        showNotify({ text: t("noDataInIncreaseUser"), customClass: "error" });
        setActiveButton(false);
        setLoading(false);
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  const chargeAccount = async () => {
    setGetAgain(1);
    const response = await AccountService.postAccountingManualCredit({
      KeyGroup: read("groupAKey"),
      KeyUser: read("userAKey"),
      TypeId: 9,
      MethodId: 4,
      Price: +convertToEnglishNumber(addUserData.priceShow),
      GroupId: row.Id,
      Describ: "شارژ اتوماتیک در زمان اضافه کردن کاربر جدید",
    });
    let err = StatusHandler(response);
    if (!err.isFail) {
      if (response.data.Value.IsError === true) {
        showNotify({ text: response.data.Value.Describ, customClass: "error" });
      } else {
        showNotify({ text: t("mission_accomplished"), customClass: "success" });
      }
      setGetAgain(2);
    } else {
      setGetAgain(0);
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="usersList" />}
        icon={<Icons.PeopleFill />}
        onClick={onShowDialog}
        className="primary-button"
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onExit}
        TransitionProps={{
          onEnter: onEnter,
          // onExit: onExit
        }}
        fullWidth
        maxWidth="lg"
      >
        <DialogHead
          text={<Translator id="usersList" />}
          icon={<Icons.PeopleFill />}
          subtext={row.Name}
        />
        <DialogContent className="p-0 py-2" id="content-dialog-manager">
          <TabContext value={tab}>
              <TabList
                onChange={handleChange}
                variant="scrollable"
                className="dialog-tab"
              >
                <Tab
                  label={
                    <div className="d-flex flex-row g-2">
                      <Icons.PeopleFill size={20} />
                      <Translator id="usersList" />
                    </div>
                  }
                  value="users-list"
                />
                <Tab
                  label={
                    <div className="d-flex flex-row g-2">
                      <Icons.PersonFillAdd size={20} />
                      <Translator id="addMoreUser" />
                    </div>
                  }
                  value="new-user"
                />
              </TabList>
            <TabPanel value="users-list" className="p-0">
              <UserTable row={row} />
            </TabPanel>
            <TabPanel value="new-user">
              <AddUser
                row={row}
                onAddUser={handleActiveShowButton}
                getAgain={getAgain}
                seterCredit={(value) => setCredit(value)}
                changeGetAgain={() => setGetAgain(0)}
              />
            </TabPanel>
          </TabContext>
        </DialogContent>
        <DialogActions>
          {activeButton && (
            <>
              <MuiButton
                className="px-4"
                color="primary"
                title={`شارژ کیف پول به مبلغ ${addUserData.priceShow.toLocaleString()} ریال`}
                onClick={chargeAccount}
                hidden={!(addUserData.priceShow > credit)}
                disabled={loading}
              />
              <MuiButton
                className="MuiButton-root MuiButtonDanger px-4"
                color="secondary"
                title={<Translator id="payByCredit" />}
                onClick={addUser}
                disabled={loading}
              />
            </>
          )}
          <MuiButton
            onClick={() => setShowDialog(false)}
            title={<Translator id="close" />}
            disabled={loading}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
